import React from 'react';
import { Link } from 'react-router-dom';
import machine1 from '../../assets/Machine1.webp';
import machine2 from '../../assets/Machine2.jpeg';
import machine3 from '../../assets/Machine3.jpeg';
import machine4 from '../../assets/Machine4.jpeg';
import machine5 from '../../assets/Machine5.jpeg';
import machine6 from '../../assets/Machine6.jpeg';
import machine7 from '../../assets/Machine7.jpeg';

const Machin = () => {
  return (
    <div className="w-full">
      {/* Hero Section */}
      <div className="w-full h-[400px] md:h-[300px] flex flex-col justify-center px-6 hero-bg-color">
        <h1 className="text-white text-4xl md:text-5xl font-bold">Machine</h1>
        <div className="text-white mt-2 text-lg">
          <Link to="/" className="underline hover:text-gray-200">Home</Link> / Machine
        </div>
      </div>

      {/* Page Content */}
      <div className="max-w-7xl mx-auto py-10 px-6">
        <hr className="border-gray-300/30 mb-10" />
        <div className="space-y-8">
          <div>
            <h2 className="text-3xl font-bold text-slate-900 mb-4">Machine Gallery</h2>
            <p className="text-gray-600 max-w-3xl">
              Explore our collection of advanced machine images representing the power and precision behind WVT Elevators solutions.
            </p>
          </div>

          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {[
              { src: machine1, alt: 'Machine 1' },
              { src: machine2, alt: 'Machine 2' },
              { src: machine3, alt: 'Machine 3' },
              { src: machine4, alt: 'Machine 4' },
              { src: machine5, alt: 'Machine 5' },
              { src: machine6, alt: 'Machine 6' },
              { src: machine7, alt: 'Machine 7' },
            ].map((image, index) => (
              <div key={index} className="overflow-hidden rounded-3xl shadow-lg bg-white h-[420px]">
                <img src={image.src} alt={image.alt} className="w-full h-full object-cover" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Machin;
